var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherDjell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.269,
    height: 31.268,
    viewBox: "0 0 31.269 31.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629",
    transform: "translate(-2838 -1251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9158",
    "data-name": "Path 9158",
    d: "M6.211,15.635A9.424,9.424,0,1,0,15.634,6.21a9.423,9.423,0,0,0-9.423,9.425",
    transform: "translate(2838 1251)",
    fill: "#f6db00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9159",
    "data-name": "Path 9159",
    d: "M11.407,25.854a13.79,13.79,0,0,1-5.992-5.987,13.8,13.8,0,0,1,0-8.463A13.767,13.767,0,0,1,11.4,5.416a13.76,13.76,0,0,1,8.458,0,13.753,13.753,0,0,1,3.468,2.522A13.9,13.9,0,0,1,25.853,11.4a13.782,13.782,0,0,1,0,8.465,13.777,13.777,0,0,1-5.989,5.987,13.776,13.776,0,0,1-8.457,0M15.634,0,11.36,5.318,4.579,4.579l.738,6.782L0,15.635l5.317,4.273-.738,6.781,6.781-.738,4.274,5.317,4.274-5.316,6.781.738-.737-6.782,5.317-4.273-5.317-4.274.737-6.782-6.781.739Z",
    transform: "translate(2838 1251)",
    fill: "#f6db00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherDjell);
export default __webpack_public_path__ + "static/media/weather_Djell.20c83f071ea895b84c3d52aa2d5c60f9.svg";
export { ForwardRef as ReactComponent };